import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-4" }
const _hoisted_2 = { class: "bf-required__icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isOpen) = $event)),
    "max-width": "420",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "bf-required pa-6",
        rounded: "xl",
        elevation: "10"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                color: "white",
                size: "30"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-lock", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "bf-required__title mt-3" }, "Acesso Suspenso", -1))
          ]),
          _createVNode(_component_v_card_text, { class: "bf-required__text text-center" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Olá! Identificamos uma pendência no pagamento da sua assinatura. ", -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" Para reativar sua conta e ter acesso completo à plataforma, por favor, regularize sua situação. ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "d-flex flex-column mt-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                color: "primary",
                class: "mb-2 text-none",
                rounded: "lg",
                size: "large",
                onClick: _ctx.goToSubscriptions
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { start: "" }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-credit-card", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[5] || (_cache[5] = _createTextVNode(" Regularizar Pagamento Agora ", -1))
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                block: "",
                variant: "outlined",
                class: "text-none",
                rounded: "lg",
                size: "large",
                onClick: _ctx.logoutNow
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { start: "" }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-logout", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[7] || (_cache[7] = _createTextVNode(" Sair da Conta ", -1))
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}